import {
	Home8,
	SubtopicFinalTeam8,
	Theme8Introduction,
	Theme8SubtopicOneActivityOne,
	Theme8SubtopicOneFinalPoints,
	Theme8SubtopicTwoActivityFive,
	Theme8SubtopicTwoActivityFour,
	Theme8SubtopicTwoActivityOne,
	Theme8SubtopicTwoActivityThree,
	Theme8SubtopicTwoActivityTwo,
	Theme8SubtopicTwoFinalPoints
} from "../pages/tema8";

export const pathTeam8 = {
	path: "home8",
	element: <Home8></Home8>,
	children: [
		{
			path: "tema8",
			children: [
				{
					path: "introduction",
					element: <Theme8Introduction></Theme8Introduction>
				},
				{
					path: "subtema1",
					children: [
						{
							path: "activityOne",
							element: <Theme8SubtopicOneActivityOne></Theme8SubtopicOneActivityOne>
						},
						{
							path: "activityresult",
							element: <Theme8SubtopicOneFinalPoints></Theme8SubtopicOneFinalPoints>
						},
					],
				},
				{
					path: "subtema2",
					children: [
						{
							path: "activityOne",
							element: <Theme8SubtopicTwoActivityOne></Theme8SubtopicTwoActivityOne>
						},
						{
							path: "activityTwo",
							element: <Theme8SubtopicTwoActivityTwo></Theme8SubtopicTwoActivityTwo>
						},
						{
							path: "activityThree",
							element: <Theme8SubtopicTwoActivityThree></Theme8SubtopicTwoActivityThree>
						},
						{
							path: "activityFour",
							element: <Theme8SubtopicTwoActivityFour></Theme8SubtopicTwoActivityFour>
						},
						{
							path: 'activityFive',
							element: <Theme8SubtopicTwoActivityFive></Theme8SubtopicTwoActivityFive>
						},
						{
							path: "activityresult",
							element: <Theme8SubtopicTwoFinalPoints></Theme8SubtopicTwoFinalPoints>
						},
					],
				},
				{
					path: "final",
					element: <SubtopicFinalTeam8></SubtopicFinalTeam8>
				},
			],
		}
	]
}